import React, { useState, useMemo, useEffect, useRef } from "react"
import Loader from "react-loader-spinner"
import axios from "axios"

export default function Loader1() {
  const [showLoader, setShowLoader] = useState(false)
  const requestCounter = useRef(0)

  useEffect(() => {
    axios.interceptors.request.use(
      response => {
        setShowLoader(true)
        requestCounter.current++;
        return response
      },
      error => {
        requestCounter.current--;
        setShowLoader(false)
        return Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      response => {
        if (requestCounter.current - 1 === 0){
          setShowLoader(false)
        }
        requestCounter.current--
        return response
      },
      error => {
        if (requestCounter.current - 1 === 0){
          setShowLoader(false)
        }
        requestCounter.current--
        return Promise.reject(error)
      }
    )
  }, [])

  return (
    <>
    {showLoader?<div
      style={{
        height: "100vh",
        width: "100%",
        background: "#80808061",
        position: "fixed",
        zIndex: showLoader ? "999999999999" : "-999999999999",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loader
        type="Grid"
        color="var(--lumiq-secondary2)"
        height={100}
        width={100}
        visible={showLoader}
      />
    </div>:null}
    </>
  )
}